import * as React from 'react'
import Paper from '@material-ui/core/Paper'
import { ViewState } from '@devexpress/dx-react-scheduler'

import moment from 'moment'
import {
  Scheduler,
  WeekView,
  Appointments,
  Toolbar,
  DateNavigator,
  TodayButton,
} from '@devexpress/dx-react-scheduler-material-ui'
import { DateTimeInput, ReferenceInput, required, SelectInput, useDataProvider, BooleanInput } from 'react-admin'
import { useState } from 'react'
import { useFormState } from 'react-final-form'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import StyledInput from '../../../../components/StyledInput'
import { optionRendererRunner } from '../../../../services/misc'

const currentDate = moment()

export const RunnersScheduleEdit = ({ record }) => {
  const dataProvider = useDataProvider()
  const { values } = useFormState()
  const [events, setEvents] = useState([])
  const [schedulerData, setSchedulerData] = useState([])

  React.useEffect(() => {
    if (values.runner_id) {
      dataProvider.getOne('runners', { id: values.runner_id }).then(({ data }) => {
        setEvents(data.events?.filter((ev) => ev.status !== 'deleted'))
      })
    }
  }, [values?.runner_id])

  React.useEffect(() => {
    setSchedulerData(
      events?.map((event) => ({
        title: event.description ? event.subject + ' (' + event.description + ')' : event.subject,
        startDate: event.start_date_time,
        endDate: event.end_date_time,
        allDay: event.is_all_day,
      })),
    )
  }, [events])

  const [currentViewName, setCurrentViewName] = useState('week')

  const currentViewNameChange = (currentViewName) => {
    setCurrentViewName(currentViewName)
  }

  const validateWhen = (selectedWhen) => {
    const endDate = moment(selectedWhen).add(30, 'minutes')
    return events
      .filter(function (e) {
        return e.id !== record?.event_id
      })
      .some((event) => hasOverlapStart(event, selectedWhen, endDate))
  }

  const validateDuration = (selectedDuration) => {
    const endDate = moment(values?.start_date_time).add(selectedDuration, 'minutes')
    return events
      .filter(function (e) {
        return e.id !== record?.event_id
      })
      .some((event) => hasOverlapStart(event, values?.start_date_time, endDate))
  }

  const hasOverlapStart = (event, newStart, newEnd) => {
    const eventStartDate = moment(event.start_date_time)
    const eventEndDate = moment(event.end_date_time)
    const newEventStartDate = moment(newStart)
    const newEventEndDate = moment(newEnd)
    const range1 = moment.range(eventStartDate, eventEndDate)
    const range2 = moment.range(newEventStartDate, newEventEndDate)
    return range1.intersect(range2) || range2.intersect(range1)
  }

  return (
    <>
      <FormRow>
        <FormCol>
          <StyledInput
            component={ReferenceInput}
            //filter={{ property_id: values?.property_id }}
            source="runner_id"
            label="Choose runner"
            disabled="true"
            validate={[required()]}
            reference="runners"
          >
            <SelectInput optionText={optionRendererRunner} />
          </StyledInput>
        </FormCol>
        <FormCol>
          <StyledInput
            component={DateTimeInput}
            ampm={false}
            locale={'it-IT'}
            source="start_date_time"
            label="Quando"
            options={{ format: 'DD/MM/YYYY, HH:mm:ss', ampm: false, clearable: true }}
            required
            validate={[required(), validateWhen]}
          />
        </FormCol>
        <FormCol>
          <StyledInput
            component={SelectInput}
            source="duration_in_min"
            choices={[
              { id: '30', name: '00:30' },
              { id: '60', name: '01:00' },
              { id: '90', name: '01:30' },
              { id: '120', name: '02:00' },
              { id: '150', name: '02:30' },
              { id: '180', name: '03:00' },
            ]}
            label="Duration"
            initialValue=""
            validate={[required(), validateDuration]}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <BooleanInput label="Mostra calendario" source="iwanttoseecalendar" />
        </FormCol>
      </FormRow>
      {values?.iwanttoseecalendar && (
        <Paper elevation={1}>
          <Scheduler data={schedulerData}>
            <ViewState
              defaultCurrentDate={currentDate}
              currentViewName={currentViewName}
              onCurrentViewNameChange={currentViewNameChange}
            />

            <WeekView name="week" cellDuration={120} startDayHour={6} endDayHour={22} />
            <Toolbar />
            <DateNavigator />
            <TodayButton />
            <Appointments />
          </Scheduler>
        </Paper>
      )}
    </>
  )
}
